
    
    <div class="main-content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header card-header-squirrel">
                            <h4 class="card-title">{{this.translate.data['CHANGEPSWD'] | translate}}</h4>
                        </div>
                        <div class="card-body">
                            <form [formGroup]="passwordForm" novalidate>

                                <mat-form-field style="width: 0; height: 0;">
                                    <input matInput hidden formControlName="userId">
                                </mat-form-field>

                                <mat-form-field class="example-full-width">
                                    <input matInput placeholder="{{this.translate.data['USERNAME'] | translate}}" formControlName="userName" readonly>
                                </mat-form-field>

                                <mat-form-field *ngIf="!forceChangPw" class="example-full-width">
                                    <input matInput placeholder="{{this.translate.data['OLDPASSWORD'] | translate}}" type="password" formControlName="oldPassword" required>
                                </mat-form-field>

                                <mat-form-field class="example-full-width">
                                    <input matInput placeholder="{{this.translate.data['PASSWORD'] | translate}}" type="password" formControlName="password" required>
                                </mat-form-field>

                                <mat-form-field class="example-full-width">
                                    <input matInput placeholder="{{this.translate.data['CONFIRMPASSWORD'] | translate}}" type="password" formControlName="confirmPassword" required>
                                </mat-form-field>
                                <span style="color: red;">mind. 8 Zeichen, mind. eine Ziffer, ein Großbuchstabe, ein Kleinbuchstabe, ein Sonderzeichen (@$!%*#?&^_-)</span>
                                <br>
                                <button *ngIf="!forceChangPw" class="btn btn-squirrel"  matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                                    (click)="cancel()" >Schließen</button>
                                <span style="flex: 1 1 auto"></span>
                                <button mat-raised-button type="submit" class="btn btn-squirrel pull-right" (click)="changePassword()">{{this.translate.data['CHANGEPASSWORD'] |
                                    translate}}</button>
                                <div class="clearfix"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  